import React, { useEffect, useState } from "react";
import { Eye, X as XIcon } from "@phosphor-icons/react";
import api, { startViewAs, stopViewAs } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function ViewAsBanner() {
  const { user } = useAuth();
  if (!user?.viewing_as) return null;
  return (
    <div data-testid="view-as-banner" className="bg-brand-yellow border-b-2 border-brand-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-between gap-3 text-sm font-bold">
        <span className="flex items-center gap-2"><Eye weight="bold" size={16} /> Vendo como: {user.viewing_as} (somente leitura)</span>
        <button data-testid="view-as-exit-btn" onClick={stopViewAs} className="btn-white !px-3 !py-1 text-xs">
          <XIcon weight="bold" size={14} /> Sair
        </button>
      </div>
    </div>
  );
}

export function ViewAsSelect() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  useEffect(() => {
    if (!user?.is_master) { return; }
    api.get("/contractors").then(r => setList(r.data)).catch(() => {});
  }, [user?.is_master]);
  if (!user?.is_master || list.length === 0) return null;
  return (
    <select
      data-testid="view-as-select"
      className="hidden lg:block border-2 border-brand-ink bg-white text-xs font-bold px-2 h-9"
      value=""
      onChange={(e) => { const c = list.find(x => x.id === e.target.value); if (c) startViewAs(c); }}
      title="Ver o sistema como uma contratante"
    >
      <option value="">Ver como contratante…</option>
      {list.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
    </select>
  );
}
